// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2NU1k","opacity1":"styles_opacity1__SvJGU","text":"styles_text__1dto5","crossholder":"styles_crossholder__2-XZ2","cross":"styles_cross__28601"};